import React from 'react';
import UserTemplateShell from '../components/UserTemplateShell';
import ExaminationAssistantPage from './ExaminationAssistantPage';

function UserExaminationTemplatePage() {
  return (
    <UserTemplateShell title="Examination Assistant" subtitle="Asisten analisis pemeriksaan">
      <ExaminationAssistantPage />
    </UserTemplateShell>
  );
}

export default UserExaminationTemplatePage;
